import { jsx as $ } from "react/jsx-runtime";
import { createContext as M, useState as O, useMemo as a, useEffect as g, useCallback as d, useContext as S } from "react";
import { b, d as j, f as B, e as F, p as G } from "./applier-hnplq_H0.js";
const A = M({
  preset: null,
  presetId: null,
  isApplied: !1,
  getComponentDefaults: () => ({}),
  getDefaultProp: () => {
  },
  switchPreset: () => {
  },
  updateOverrides: () => {
  },
  availablePresets: /* @__PURE__ */ new Map()
});
function z({
  children: s,
  presetId: r,
  overrides: u,
  applyToDom: c = !0,
  target: p,
  fallbackPresetId: i,
  onPresetChange: P,
  onError: v
}) {
  const [t, x] = O(r), [l, m] = O(u), n = a(() => {
    try {
      return b(t, l);
    } catch (e) {
      if (i && i !== t) {
        console.warn(
          `Preset "${t}" not found, using fallback "${i}"`
        );
        try {
          return b(i, l);
        } catch {
        }
      }
      return v ? v(e, t) : console.error(`Failed to resolve preset "${t}":`, e), null;
    }
  }, [t, l, i, v]);
  g(() => {
    if (!(typeof document > "u" || !c)) {
      if (n) {
        const e = p || document.documentElement;
        j(t, {
          target: e,
          overrides: l
        }), P && P(t, n);
      }
      return () => {
        if (c) {
          const e = p || document.documentElement;
          B(e) === t && F(e);
        }
      };
    }
  }, [t, n, c, p, l, P]), g(() => {
    x(r);
  }, [r]), g(() => {
    m(u);
  }, [u]);
  const f = d(
    (e) => n ? n.componentDefaults[e] || {} : {},
    [n]
  ), D = d(
    (e, o) => f(e)[o],
    [f]
  ), w = d(
    (e, o) => {
      x(e), o !== void 0 && m(o);
    },
    []
  ), y = d((e) => {
    m((o) => ({
      ...o,
      ...e
    }));
  }, []), h = a(() => G.getGroupedByCategory(), []), E = a(
    () => ({
      preset: n,
      presetId: n ? t : null,
      isApplied: n !== null,
      getComponentDefaults: f,
      getDefaultProp: D,
      switchPreset: w,
      updateOverrides: y,
      availablePresets: h
    }),
    [
      n,
      t,
      f,
      D,
      w,
      y,
      h
    ]
  );
  return /* @__PURE__ */ $(A.Provider, { value: E, children: s });
}
function C() {
  return S(A);
}
function H(s) {
  const { getComponentDefaults: r } = C();
  return a(
    () => r(s),
    [r, s]
  );
}
function J(s, r) {
  const { getDefaultProp: u } = C();
  return a(
    () => u(s, r),
    [u, s, r]
  );
}
function K() {
  const { switchPreset: s, availablePresets: r, presetId: u, updateOverrides: c } = C();
  return {
    switchPreset: s,
    availablePresets: r,
    currentPresetId: u,
    updateOverrides: c
  };
}
export {
  z as P,
  H as a,
  J as b,
  K as c,
  C as u
};
